import { CircularProgress } from "@mui/material";
import { ThemeTabsProps } from "../../../interfaces/themes";

const ThemeTabs: React.FC<ThemeTabsProps> = ({
  categories,
  activeKey,
  onChange,
  isLoading = false,
}) => {
  return (
    <div
      className="theme-summary-grid"
      role="tablist"
      aria-label="Theme categories"
    >
      {categories.map((category) => (
        <button
          key={category.key}
          type="button"
          role="tab"
          aria-selected={activeKey === category.key}
          className={`theme-tab theme-tab--${category.key} ${
            activeKey === category.key ? "theme-tab--active" : ""
          }`}
          onClick={() => onChange(category.key)}
        >
          <span className="theme-tab__label">{category.label}</span>
          <span className="theme-tab__value-row" aria-live="polite">
            {isLoading ? (
              <CircularProgress
                size={20}
                thickness={5}
                aria-label="Loading count"
              />
            ) : (
              <span className="theme-tab__value">{category.count}</span>
            )}
            <span className="theme-tab__dot" aria-hidden="true" />
          </span>
        </button>
      ))}
    </div>
  );
};

export default ThemeTabs;
